import { IntlProvider } from 'react-intl';

import { DEFAULT_LOCALE } from '@/configuration/lang/lang';
import { getDisplayMessages, getLocale } from '@/configuration/lang/langSlice';
import { useAppSelector } from '@/configuration/setup/hooks';
import MainComponent from './MainComponent';
import MessageHandler from './MessageHandler';

import './App.css';

const App = () => {
    const userLocale = useAppSelector(getLocale);
    const displayMessages = useAppSelector(getDisplayMessages);

    if (!displayMessages || !userLocale) {
        return null;
    }

    return (
        <IntlProvider defaultLocale={DEFAULT_LOCALE} key={userLocale} locale={userLocale} messages={displayMessages}>
            <MainComponent />
            <MessageHandler />
        </IntlProvider>
    );
};

export default App;
